import React, { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const Blogs = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const WORDPRESS_API =
    "https://public-api.wordpress.com/wp/v2/sites/smafathersorg.wordpress.com/pages?per_page=100";

  useEffect(() => {
    fetch(WORDPRESS_API)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const sorted = data.sort(
            (a, b) => new Date(b.modified) - new Date(a.modified)
          );
          setPages(sorted);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading WordPress pages:", error);
        setLoading(false);
      });
  }, []);

  const getFirstImage = (html) => {
    if (!html) return null;
    const match = html.match(/<img[^>]+src="([^">]+)"/);
    return match ? match[1] : null;
  };

  const getTextPreview = (html, length = 150) => {
    if (!html) return "";
    const text = html.replace(/<[^>]+>/g, "");
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  return (
    <section className="scroll-section container">
      <h2 className="mb-4">Latest Blogs</h2>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {pages.map((page) => {
            const image = getFirstImage(page?.content?.rendered);
            const preview = getTextPreview(page?.content?.rendered);

            return (
              <Card
                key={page.id}
                className="p-3 shadow-sm"
                style={{ cursor: "pointer" }}
                onClick={() => history.push(`/blog/${page.slug}`)}
              >
                <div className="d-flex align-items-start gap-3">

                  {/* FIXED IMAGE CONTAINER */}
                  {image && (
                    <div
                      style={{
                        width: "120px",
                        height: "120px",
                        overflow: "hidden",
                        borderRadius: "8px",
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={image}
                        alt="blog"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  )}

                  {/* TEXT CONTENT */}
                  <div style={{ flex: 1 }}>
                    <h5
                      dangerouslySetInnerHTML={{
                        __html: page?.title?.rendered || "Untitled",
                      }}
                    />
                    <p className="text-muted mb-0">{preview}</p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default Blogs;
